'use strict';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var moment = require('moment-timezone');
/**
 * @author Sebastian Pekarek
 * @module ical-generator
 * @class ICalTools
 */

var ICalTools = /*#__PURE__*/function () {
  function ICalTools() {
    _classCallCheck(this, ICalTools);
  }
  _createClass(ICalTools, null, [{
    key: "formatDate",
    value: function formatDate(timezone, d, dateonly, floating) {
      var m = timezone ? moment(d).tz(timezone) : moment(d).utc();
      if (!dateonly && !floating) {
        m = moment(d).utc();
      }
      var s = m.format('YYYYMMDD');
      if (!dateonly) {
        s += 'T';
        s += m.format('HHmmss');
        if (!floating) {
          s += 'Z';
        }
      }
      return s;
    } // For information about this format, see RFC 5545, section 3.3.5
    // https://tools.ietf.org/html/rfc5545#section-3.3.5
  }, {
    key: "formatDateTZ",
    value: function formatDateTZ(timezone, property, date, eventData) {
      var tzParam = '';
      var floating = eventData.floating;
      if (eventData.timezone) {
        tzParam = ';TZID=' + eventData.timezone; // This isn't a 'floating' event because it has a timezone;
        // but we use it to omit the 'Z' UTC specifier in formatDate()

        floating = true;
      }
      return property + tzParam + ':' + module.exports.formatDate(timezone, date, false, floating);
    }
  }, {
    key: "escape",
    value: function escape(str) {
      return String(str).replace(/[\\;,"]/g, function (match) {
        return '\\' + match;
      }).replace(/(?:\r\n|\r|\n)/g, '\\n');
    }
  }, {
    key: "toJSON",
    value: function toJSON(object, attributes, options) {
      var result = {};
      options = options || {};
      options.ignoreAttributes = options.ignoreAttributes || [];
      options.hooks = options.hooks || {};
      attributes.forEach(function (attribute) {
        if (options.ignoreAttributes.indexOf(attribute) !== -1) {
          return;
        }
        var value = object[attribute](),
          newObj;
        if (moment.isMoment(value)) {
          value = value.toJSON();
        }
        if (options.hooks[attribute]) {
          value = options.hooks[attribute](value);
        }
        if (!value) {
          return;
        }
        result[attribute] = value;
        if (Array.isArray(result[attribute])) {
          newObj = [];
          result[attribute].forEach(function (object) {
            newObj.push(object.toJSON());
          });
          result[attribute] = newObj;
        }
      });
      return result;
    }
  }, {
    key: "foldLines",
    value: function foldLines(input) {
      return input.split('\r\n').map(function (line) {
        return line.match(/(.{1,74})/g).join('\r\n ');
      }).join('\r\n');
    }
  }, {
    key: "addOrGetCustomAttributes",
    value: function addOrGetCustomAttributes(instance, keyOrArray, value) {
      if (Array.isArray(keyOrArray)) {
        instance._data.x = keyOrArray.map(function (o) {
          if (typeof o.key !== 'string' || typeof o.value !== 'string') {
            throw new Error('Either key or value is not a string!');
          }
          if (o.key.substr(0, 2) !== 'X-') {
            throw new Error('Key has to start with `X-`!');
          }
          return [o.key, o.value];
        });
      } else if (_typeof(keyOrArray) === 'object') {
        instance._data.x = Object.entries(keyOrArray).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          if (typeof key !== 'string' || typeof value !== 'string') {
            throw new Error('Either key or value is not a string!');
          }
          if (key.substr(0, 2) !== 'X-') {
            throw new Error('Key has to start with `X-`!');
          }
          return [key, value];
        });
      } else if (typeof keyOrArray === 'string' && typeof value === 'string') {
        if (keyOrArray.substr(0, 2) !== 'X-') {
          throw new Error('Key has to start with `X-`!');
        }
        instance._data.x.push([keyOrArray, value]);
      } else if (keyOrArray !== undefined || value !== undefined) {
        throw new Error('Either key or value is not a string!');
      } else {
        return instance._data.x.map(function (a) {
          return {
            key: a[0],
            value: a[1]
          };
        });
      }
      return instance;
    }
  }, {
    key: "generateCustomAttributes",
    value: function generateCustomAttributes(instance) {
      var str = instance._data.x.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return key.toUpperCase() + ':' + ICalTools.escape(value);
      }).join('\r\n');
      return str.length ? str + '\r\n' : '';
    }
  }]);
  return ICalTools;
}();
module.exports = ICalTools;